// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".component-program-popover{padding:15px;min-width:300px;max-width:380px}", "",{"version":3,"sources":["webpack://./src/ui/components/ProgramPopover.sass"],"names":[],"mappings":"AAAA,2BACE,YAAA,CACA,eAAA,CACA,eAAA","sourcesContent":[".component-program-popover\r\n  padding: 15px\r\n  min-width: 300px\r\n  max-width: 380px\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
